import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/examineeManage',
  redirect: 'noredirect',
  name: 'examineeManage',
  component: Layout,
  children: [
    {
      path: 'examineeManage',
      component: () => import('@/views/examineeManage/index.vue'),
      name: 'Apparatus',
      meta: {
        title: '用户管理',
        icon: 'resource',
        requireAuth: true,
      }
    },
  ]

}

export default equipRouter
